<script>
	import thumb_qJQEUSqrzeQ from '$lib/Components/Youtube/images/qJQEUSqrzeQ.jpg?w=610';

	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import Youtube from '$lib/Components/Youtube/Youtube.svelte';
	import MeasureSupport from '$lib/PageSections/Forms/MeasureSupport/MeasureSupport.svelte';
	import GetAFreeEstimate from '$lib/PageSections/GetAFreeEstimate/GetAFreeEstimate.svelte';
	import GradeTypes from '$lib/PageSections/GradeTypes/GradeTypes.svelte';

	import karen from './images/Karen-Measuring.jpg';
</script>

<Section backgroundColor="white">
	<p>
		Need help finding the portal for measurements? Installing your new Indow
		window insert? Issuing a claim for a damaged insert? You’re in the right
		place!
	</p>
	<p>
		You can’t enter window measurements here, but we can direct you to the right
		place.
	</p>
	<Image src={karen} alt="Indow window measure and installation support." />
</Section>

<Section backgroundColor="white">
	<h2>Measure Portal for Indow Windows</h2>
	<p>
		You need to provide your measurement details through Measure by Indow. A
		link to the measure form should have been provided in the first email after
		your order was confirmed. If you can’t find it, don’t panic! Let us know and
		we can help with your measurements, measure kits (laser measure kit),
		consultation to measurement, or anything you need.
	</p>
	<div class="flex flex-col gap-4 px-6">
		<div class="rounded-lg bg-indow-white p-6 shadow-lg">
			<MeasureSupport />
		</div>
	</div>
</Section>

<Section backgroundColor="white">
	<h2>Indow Insert Installation Guide</h2>
	<p>
		You should have received your installation instructions with your inserts.
		The installation video below will walk you through how to install your
		window insert step by step. We have more <a
			href="https://www.youtube.com/watch?v=TNTM7OuuYWw&list=PLe64DtqOvhg5eBSxabLVP7fUhWsWa2v0V"
			target="_blank"
			rel="noreferrer">installation videos</a
		>
		on our YouTube. Please also review our
		<a href="/about-indow/care">care guide</a> for proper cleaning instructions.
	</p>
	<Youtube posterImageSrc={thumb_qJQEUSqrzeQ} videoId="qJQEUSqrzeQ" />
</Section>

<Section backgroundColor="white">
	<h2>Other Order Issues?</h2>
	<p>
		If you have any other issues with your order, <a href="/about-indow/contact"
			>we’re here to help</a
		>! We have a
		<a href="/about-indow/care/installation-resources">customer resource page</a
		>
		with advice on measuring, installing, or caring for your insert. If your inserts
		arrived damaged, keep the packaging they arrived in and
		<a href="/claim-submission-customer">submit a claim</a>.
	</p>
	<p>
		We want to make sure every part of the process goes as smoothly as possible,
		so please don’t hesitate in reaching out.
	</p>
</Section>
<GradeTypes backgroundColor="grey" />
<GetAFreeEstimate />
